import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type StackPullRequestsTableExpandedRowsStore = {
  expandedRows: Set<string>;
  toggleRow: (rowKey: string) => void;
};

const useStackPullRequestsTableExpandedRowsStore =
  create<StackPullRequestsTableExpandedRowsStore>()(
    immer((set) => ({
      expandedRows: new Set(),

      toggleRow: (rowKey) =>
        set((state) => {
          if (state.expandedRows.has(rowKey)) {
            state.expandedRows.delete(rowKey);
          } else {
            state.expandedRows.add(rowKey);
          }
        }),
    }))
  );

export default useStackPullRequestsTableExpandedRowsStore;
